export const contactsData = {
    email: 'samorji18@gmail.com',
    phone: '+18067847275',
    address: 'Lubbock, Texas, United States',

    sheetAPI: ''
}